import { render, staticRenderFns } from "./_security.vue?vue&type=template&id=df1990ec&lang=pug&"
import script from "./_security.vue?vue&type=script&lang=js&"
export * from "./_security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports